import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_GET_BY_ID } from 'api/utilityActionTypes';

export default async function loadCurrentUtilityPartner(
  { state, utilityApiClient },
  { id, forceRefresh = false },
) {
  typeCheck('id::PositiveNumber', id);

  const currentPartnerStatePath = ['utilityPartners', 'currentPartner'];

  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }
  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_GET_BY_ID,
    queryId: String(id),
    state: state,
    payload: {
      id: id,
    },
    onSuccess(partner) {
      if (!partner) {
        return;
      }

      state.set(currentPartnerStatePath, partner);
      state.set(['utilityPartners', 'bySlug', partner.slug], partner);
    },
  });
}
